import information_product_img from '../img/heroSuggest/Fuji_D2_45M_en_US_1x._CB418309979_.jpg';

export const informationProduct = {
    title: 'Sign in for the best experience',
    button_title: 'Sign in securely',
    img: information_product_img
}